class FolderBreadcrumb extends HTMLElement {
    static observedAttributes = ['project-id', 'dept-id', 'path', 'dept-name', 'link-id'];

    constructor() {
        super();
    }

    attributeChangedCallback(attrName, oldValue, newValue) {
        this.dynamicRender();
    }

    connectedCallback() {
        if (!this.shadowRoot) {
            this.attachShadow({mode: 'open'});

            // Append site stylesheet
            const styleSheet = document.createElement('link');
            styleSheet.setAttribute('rel', 'stylesheet');
            styleSheet.setAttribute('href', '/dist/style.css');
            this.shadowRoot.appendChild(styleSheet);

            this._breadcrumb = document.createElement('bread-crumb');
            this.shadowRoot.appendChild(this._breadcrumb);
        }

        this.dynamicRender();
    }

    setupEvents() {

    }

    dynamicRender() {
        if ('undefined' === typeof(this._breadcrumb)) return;

        this._breadcrumb.innerHTML = '';
        let html = '';

        const projectID = +this.getAttribute('project-id');
        const deptID = +(this.getAttribute('dept-id') ?? -1);
        const linkID = this.getAttribute('link-id') ?? '';

        // Add dept if needed
        if (deptID > 0) {
            let deptName = this.getAttribute('dept-name') ?? 'Unknown';

            html += `<a href="${this.generateURL(projectID, deptID, '/', linkID)}"><div><img src="/img/Dept_Folder.svg"/>${deptName}</div></a>`;
        } else {
            // Add Files entry
            html += `<a href="${this.generateURL(projectID, -1, '/', linkID)}"><div><img src="/img/Folder.svg"/>Files</div></a>`;
        }

        // Split path
        const components = (this.getAttribute('path') ?? '/').split('/');
        let currentPath = '';

        for (const component of components) {
            if (component.trim().length === 0) continue;
            currentPath += '/' + component;

            html += `<a href="${this.generateURL(projectID, deptID, currentPath, linkID)}"><div><img src="/img/Folder.svg"/>${component}</div></a>`;
        }

        this._breadcrumb.insertAdjacentHTML('beforeend', html);
    }

    generateURL(projectID, deptID, path, linkID) {
        let url = `/files?dept=${deptID}&folder=${encodeURIComponent(path)}`;
        if (projectID !== 0) url += `&project=${projectID}`;
        if (linkID) url += `&link=${linkID}`;
        return url;
    }



}

customElements.define('folder-breadcrumb', FolderBreadcrumb);

